<template>
  <v-row dense>
    <v-col cols="12">
      <span class="font-weight-bold">カード使用日: </span>
      <MarkTag :text="getContent.date" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">支払先: </span>
      <MarkTag :text="getContent.payee" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">使用目的: </span>
      <MarkTag :text="getContent.items.join('、')" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">カード: </span>
      <MarkTag :text="`${getContent.card}（${getContent.holder}）`" :match="getQuery" />
    </v-col>
    <v-col cols="12">
      <span class="font-weight-bold">決済金額: </span>
      <MarkTag :text="getContent.payment" :match="getQuery" />
    </v-col>
    <v-col cols="12" v-if="getContent.price">
      <span class="font-weight-bold">お客さんへの価格: </span>
      <MarkTag :text="getContent.price" :match="getQuery" />
    </v-col>
    <v-col cols="12" v-if="getContent.note">
      <span class="font-weight-bold">備考欄: </span>
      <MarkTag :text="getContent.note" :match="getQuery" />
    </v-col>
  </v-row>
</template>

<script>
import MarkTag from '@/components/tags/mark'
export default {
  name: 'postCreditLayout',
  props: [ 'item' ],
  components: {
    MarkTag
  },
  computed: {
    getQuery () {
      return this.$route.query && this.$route.query.query
    },
    getContent () {
      return (this.$props.item && this.$props.item.content) ? Object.assign(JSON.parse(this.$props.item.content), {
        date: this.$props.item.date ? this.$moment(this.$props.item.date).format('YYYY年MM月DD日') : ''
      }) : ''
    }
  }
}
</script>